import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import t from "../translate"
import LeftMenu from "../leftmenu"
import apiCall from "../api"

const GenerateNewAccounts = props => {

  const auth = useSelector(state => state.auth)

  const [formContent, setFormContent] = useState({
    emailaddresses: '',
    language_id: 0,
    intervention_id: 0,
    emailtext: '',
    university: ''
  })
  const [languages, setLanguages] = useState([])
  const [universities, setUniversities] = useState([])
  const [errorMessage, setErrorMessage] = useState("")
  const [successMessage, setSuccessMessage] = useState("")
  const [mailPreview, setMailPreview] = useState(null)
  const [showPreview, setShowPreview] = useState(false)

  useEffect(() => {
    apiCall({
      action: "get_languages",
      token: auth.token,
      data: {}
    }).then(resp => {
      setLanguages(resp.languages)
    })

    apiCall({
      action: "get_universities",
      data: {}
    }).then(resp => {
      if (resp && resp.universities) {
        setUniversities(resp.universities)
      }
    })
  }, [])

  function onChange(e) {
    setErrorMessage("")
    let newFormContent = {...formContent}
    newFormContent[e.target.name] = e.target.value
    setFormContent(newFormContent)
  }

  function loadMailPreview() {
    apiCall({
      action: "get_mail_preview",
      token: auth.token,
      data: {
        language_id: formContent.language_id > 0 ? formContent.language_id : 1,
        emailtext: formContent.emailtext
      }
    }).then(resp => {
      if (resp && resp.subject) {
        setMailPreview(resp)
        setShowPreview(true)
      }
    })
  }

  function generateNewAccounts() {
    setErrorMessage("")
    setSuccessMessage("")
    apiCall({
      action: "generate_accounts",
      token: auth.token,
      data: {
        emailaddresses: formContent.emailaddresses,
        intervention_id: formContent.intervention_id,
        language_id: formContent.language_id,
        emailtext: formContent.emailtext,
        university: formContent.university
      }
    }).then(resp => {
      if (resp.generate_accounts) {
        setSuccessMessage(resp.msg)
        setFormContent({
          emailaddresses: '',
          language_id: 0,
          intervention_id: 0,
          emailtext: '',
          university: ''
        })
      } else {
        setErrorMessage(resp.msg)
      }
    })
  }

  return (
    <div className="transWrapper">
      <div className="container dashboard admin">
        <LeftMenu />

        <div>
          <h2>{t("Genereren studentenaccounts")}</h2>
          <p>{t("Vul onderstaand formulier in en klik op 'Genereer accounts'. De logingegevens van de nieuw gegenereerde accounts worden vervolgens hier weergegeven en per e-mail aan u verzonden.")}</p>
          {
            errorMessage.length > 0 ?
            <div className="alert alert-danger">
              <i className="fas fa-exclamation-circle"></i> &nbsp;
              <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
            </div>
            : <></>
          }
          {
            successMessage.length > 0 ?
            <div className="alert alert-success">
              <span dangerouslySetInnerHTML={{ __html: successMessage }} />
            </div>
            : <></>
          }
          <br />
          <textarea
            className="form-control"
            name="emailaddresses"
            id="emailaddresses"
            placeholder={t("Plak hier de emailadressen waarvoor u een account wil aanmaken. Deze mogen gescheiden zijn door een spatie, tab, komma, puntkomma of witregel/enter.")}
            value={formContent.emailaddresses}
            onChange={onChange}
            style={{height: '170px', border: '1px solid #ced4da', borderRadius: '5px', padding: '10px'}}
          />
          <br />

          <select
            name="intervention_id"
            id="intervention_id"
            className="custom-select"
            style={{width: "100%"}}
            onChange={(e) => onChange(e)}
            value={formContent.intervention_id}>
            <option value="0">{t("Selecteer programma")}</option>
            {
              props.interventions.map((int, index) => {
                return(
                  <option key={index} value={int.id}>{int.title}</option>
                )
              })
            }
          </select>

          <br />
          <br />

          <select
            name="language_id"
            id="language_id"
            className="custom-select"
            style={{width: "100%"}}
            onChange={(e) => onChange(e)}
            value={formContent.language_id}>
            <option value="0">{t("Selecteer taal (Studenten kunnen deze taal alsnog aanpassen via hun profiel)")}</option>
            {
              languages.map((option, index) => {
                return(
                  <option key={index} value={option.id}>{option.language} ({option.code})</option>
                )
              })
            }
          </select>

          <br />
          <br />

          <select
            name="university"
            id="university"
            className="custom-select"
            style={{width: "100%"}}
            onChange={(e) => onChange(e)}
            value={formContent.university}>
            <option value="">{t("Selecteer universiteit (verplicht, geldt voor alle accounts)")}</option>
            {
              universities.map((uni, index) => {
                return(
                  <option key={index} value={uni}>{uni}</option>
                )
              })
            }
          </select>

          <br />
          <br />

          <textarea
            className="form-control"
            name="emailtext"
            id="emailtext"
            placeholder={t("Optioneel: Schrijf hier de tekst die u in wilt voegen in de e-mail die de studenten ontvangen.")}
            value={formContent.emailtext}
            onChange={onChange}
            style={{height: '170px', border: '1px solid #ced4da', borderRadius: '5px', padding: '10px'}}
          />
          <br />

          <span className="btn btn-outline-secondary" onClick={loadMailPreview}>
            <i className="fas fa-eye"></i> &nbsp;
            {t("Bekijk volledige e-mail")}
          </span>

          {showPreview && mailPreview ?
            <div style={{marginTop: '15px', border: '1px solid #dee2e6', borderRadius: '5px', padding: '20px', backgroundColor: '#f8f9fa'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                <h5 style={{margin: 0}}>{t("E-mail preview")}</h5>
                <span className="btn btn-sm btn-outline-secondary" onClick={() => setShowPreview(false)}>
                  <i className="fas fa-times"></i>
                </span>
              </div>
              <p><strong>{t("Onderwerp")}:</strong> {mailPreview.subject}</p>
              <hr />
              <div dangerouslySetInnerHTML={{ __html: mailPreview.body }} />
            </div>
            : <></>
          }

          <br />

          <span className="btn btn-primary float-right" onClick={() => generateNewAccounts()}>
            {t("Genereer accounts")}
          </span>
        </div>

      </div>
    </div>
  )

}

export default GenerateNewAccounts;
